import { createSlice } from "@reduxjs/toolkit";
import {
  addCity,
  addCountry,
  addDistrict,
  addState,
  deleteCity,
  deleteCountry,
  deleteDistrict,
  deleteState,
  getCities,
  getCountries,
  getDistricts,
  getStates,
  updateCity,
  updateCountry,
  updateDistrict,
  updateState,
} from "./actions/locations.actions";

const initialState = {
  loading: false,
  isEditing: false,

  countries: null,
  totalCountries: 0,
  country: null,
  countryFilter: {},
  countryPageState: { page: 1, pageSize: 50 },

  states: null,
  totalStates: 0,
  state: null,
  stateFilter: {},
  statePageState: { page: 1, pageSize: 50 },

  districts: null,
  totalDistricts: 0,
  district: null,
  districtFilter: {},
  districtPageState: { page: 1, pageSize: 50 },

  cities: null,
  totalCities: 0,
  city: null,
  cityFilter: {},
  cityPageState: { page: 1, pageSize: 50 },
};

export const locationSlice = createSlice({
  name: "location",
  initialState,
  reducers: {
    setCountry: (state, action) => {
      const country = state.countries.find((loc) => loc.id === action.payload);
      state.country = country;
    },
    setState: (state, action) => {
      const _state = state.states.find((loc) => loc.id === action.payload);
      state.state = _state;
    },
    setDistrict: (state, action) => {
      const district = state.districts.find((loc) => loc.id === action.payload);
      state.district = district;
    },
    setCity: (state, action) => {
      const city = state.cities.find((loc) => loc.id === action.payload);
      state.city = city;
    },
    setIsEditing: (state, action) => {
      state.isEditing = action.payload;
    },

    setCountryFilter: (state, action) => {
      state.countryFilter = action.payload;
    },
    resetCountryFilter: (state) => {
      state.countryFilter = {};
    },

    setStateFilter: (state, action) => {
      state.stateFilter = action.payload;
    },
    resetStateFilter: (state) => {
      state.stateFilter = {};
    },

    setDistrictFilter: (state, action) => {
      state.districtFilter = action.payload;
    },
    resetDistrictFilter: (state) => {
      state.districtFilter = {};
    },

    setCityFilter: (state, action) => {
      state.cityFilter = action.payload;
    },
    resetCityFilter: (state) => {
      state.cityFilter = {};
    },

    setCityPage: (state, action) => {
      const { page, pageSize } = action.payload;
      if (page) {
        state.cityPageState = { ...state.cityPageState, page };
      }
      if (pageSize) {
        state.cityPageState = { ...state.cityPageState, pageSize };
      }
    },
    setDistrictPage: (state, action) => {
      const { page, pageSize } = action.payload;
      if (page) {
        state.districtPageState = { ...state.districtPageState, page };
      }
      if (pageSize) {
        state.districtPageState = { ...state.districtPageState, pageSize };
      }
    },
    setStatePage: (state, action) => {
      const { page, pageSize } = action.payload;
      if (page) {
        state.statePageState = { ...state.statePageState, page };
      }
      if (pageSize) {
        state.statePageState = { ...state.statePageState, pageSize };
      }
    },
    setCountryPage: (state, action) => {
      const { page, pageSize } = action.payload;
      if (page) {
        state.countryPageState = { ...state.countryPageState, page };
      }
      if (pageSize) {
        state.countryPageState = { ...state.countryPageState, pageSize };
      }
    },
  },
  extraReducers: (builder) => {
    // countries
    builder
      .addCase(getCountries.pending, (state) => {
        state.loading = true;
      })
      .addCase(getCountries.fulfilled, (state, action) => {
        const { data, count } = action.payload;
        state.loading = false;
        state.countries = data;
        state.totalCountries = count;
      })
      .addCase(getCountries.rejected, (state) => {
        state.loading = false;
      })
      .addCase(addCountry.fulfilled, (_, action) => {
        console.log(action.payload);
        window.location.hash = "#/preferences/location?type=country";
      })
      .addCase(updateCountry.fulfilled, (state, action) => {
        state.isEditing = false;
        state.country = action.payload;
      })
      .addCase(updateCountry.rejected, (state, action) => {
        console.log(action.payload);
        state.isEditing = false;
      })
      .addCase(deleteCountry.fulfilled, (_, action) => {
        console.log(action.payload);
        window.location.hash = "#/preferences/location?type=country";
      });

    // states
    builder
      .addCase(getStates.pending, (state) => {
        state.loading = true;
      })
      .addCase(getStates.fulfilled, (state, action) => {
        const { data, count } = action.payload;
        state.loading = false;
        state.states = data;
        state.totalStates = count;
      })
      .addCase(getStates.rejected, (state) => {
        state.loading = false;
      })
      .addCase(addState.fulfilled, (_, action) => {
        console.log(action.payload);
        window.location.hash = "#/preferences/location?type=state";
      })
      .addCase(updateState.fulfilled, (state, action) => {
        state.isEditing = false;
        state.state = action.payload;
      })
      .addCase(updateState.rejected, (state, action) => {
        console.log(action.payload);
        state.isEditing = false;
      })
      .addCase(deleteState.fulfilled, (_, action) => {
        console.log(action.payload);
        window.location.hash = "#/preferences/location?type=state";
      });

    // districts
    builder
      .addCase(getDistricts.pending, (state) => {
        state.loading = true;
      })
      .addCase(getDistricts.fulfilled, (state, action) => {
        const { data, count } = action.payload;
        state.loading = false;
        state.districts = data;
        state.totalDistricts = count;
      })
      .addCase(getDistricts.rejected, (state) => {
        state.loading = false;
      })
      .addCase(addDistrict.fulfilled, (_, action) => {
        console.log(action.payload);
        window.location.hash = "#/preferences/location?type=district";
      })
      .addCase(updateDistrict.fulfilled, (state, action) => {
        state.isEditing = false;
        state.district = action.payload;
      })
      .addCase(updateDistrict.rejected, (state, action) => {
        console.log(action.payload);
        state.isEditing = false;
      })
      .addCase(deleteDistrict.fulfilled, (_, action) => {
        console.log(action.payload);
        window.location.hash = "#/preferences/location?type=district";
      });

    // cities
    builder
      .addCase(getCities.pending, (state) => {
        state.loading = true;
      })
      .addCase(getCities.fulfilled, (state, action) => {
        const { data, count } = action.payload;
        state.loading = false;
        state.cities = data;
        state.totalCities = count;
      })
      .addCase(getCities.rejected, (state) => {
        state.loading = false;
      })
      .addCase(addCity.fulfilled, (_, action) => {
        console.log(action.payload);
        window.location.hash = "#/preferences/location?type=city";
      })
      .addCase(updateCity.fulfilled, (state, action) => {
        state.isEditing = false;
        state.city = action.payload;
      })
      .addCase(updateCity.rejected, (state, action) => {
        console.log(action.payload);
        state.isEditing = false;
      })
      .addCase(deleteCity.fulfilled, (_, action) => {
        console.log(action.payload);
        window.location.hash = "#/preferences/location?type=city";
      });
  },
});

export const {
  setCountry,
  setState,
  setDistrict,
  setCity,
  setIsEditing,
  setCountryFilter,
  resetCountryFilter,
  setStateFilter,
  resetStateFilter,
  setDistrictFilter,
  resetDistrictFilter,
  setCityFilter,
  resetCityFilter,
  setCityPage,
  setDistrictPage,
  setStatePage,
  setCountryPage,
} = locationSlice.actions;

export default locationSlice.reducer;
